import React from "react";
import { useDispatch } from "react-redux";
import { searching } from "../redux/blogs/actions";
import { author_search, category_search } from "../redux/search_bar/actions";

export default function BlogsCard({ blog }) {
  const dispatch = useDispatch();
  const authorSearchHander = (author_name) => {
    dispatch(author_search(author_name));
  };
  const categorySearchHander = (category) => {
    dispatch(category_search(category));
  };
  return (
    <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
      <div className="flex-shrink-0">
        <img className="h-48 w-full object-cover" src={blog.img} alt="" />
      </div>
      <div className="flex-1 bg-white p-6 flex flex-col justify-between">
        <div className="flex-1">
          <p
            className="text-sm font-medium text-indigo-600"
            onClick={() => categorySearchHander(blog.category)}
          >
            <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 hover:bg-indigo-200 cursor-pointer">
              {blog.category}
            </span>
          </p>
          <a href="#" className="block mt-1">
            <p className="text-xl font-semibold text-gray-900">{blog.title}</p>
          </a>
        </div>
        <div className="mt-6 flex items-center">
          <div
            onClick={() => authorSearchHander(blog.author_name)}
            className="flex-shrink-0"
          >
            <img
              className="h-10 w-10 rounded-full cursor-pointer"
              src={blog.author_img}
              alt=""
            />
          </div>
          <div className="ml-3">
            <p
              onClick={() => authorSearchHander(blog.author_name)}
              className="text-sm font-medium text-gray-900 hover:underline cursor-pointer"
            >
              {blog.author_name}
            </p>
            <div className="flex space-x-1 text-sm text-gray-500">
              <time dateTime="2020-03-16">{blog.time}</time>
              <span aria-hidden="true">·</span>
              <span> {blog.read} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
